import { render, staticRenderFns } from "./BagworldPage.vue?vue&type=template&id=18c14b53&"
import script from "./BagworldPage.vue?vue&type=script&lang=js&"
export * from "./BagworldPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports